import { useEffect, useRef } from "react";

export default function useSubscribe(store, handler, deps = []) {
  const isInitial = useRef(true);
  useEffect(() => {
    const unsub = store.subscribe((s) => {
      handler(s, isInitial.current);
      isInitial.current = false;
    });

    return () => {
      unsub();
    };
  }, [...deps]);
}
